'use strict';

angular.module('mean.projects').factory('lotTaskDataService', ['$filter', 'ProjectTasks', '$q', 'taskService',
    function($filter, ProjectTasks, $q, taskService) {

        var get = function(project, ordered_lots) {
            var deferred = $q.defer();
            var list = [];
            ordered_lots.forEach(function(lot) {
                taskService.getByProjectIdLot(project._id, lot).then(function(results) {
                    list.push(results);
                });
            });

            $q.all(list).then(function(results) {
                deferred.resolve(results);
            });

            return deferred.promise;
        };

        return {
            get: get
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/lot-task-data-service.js